// Two grounds for the same ledger. Light is the default: warm paper rather than
// stark white, so the heirloom-ledger character survives the switch.
export const TOKENS = {
  light: {
    ground: '#FAF6EF',     // warm paper
    surface: '#FFFFFF',
    surfaceHi: '#F4EDE2',  // hover / nested
    line: '#E5DACA',       // warm hairline
    textHi: '#241C14',
    textLo: '#6E6357',
    railBg: '#F4EDE2',
    gridLine: 'rgba(36,28,20,0.08)',
    hoverWash: 'rgba(36,28,20,0.04)',
    trackBg: 'rgba(36,28,20,0.08)',
  },
  dark: {
    ground: '#14110F',     // warm charcoal, never blue-black
    surface: '#1C1815',
    surfaceHi: '#241F1B',
    line: '#332C26',
    textHi: '#F2EDE7',
    textLo: '#A79E95',
    railBg: '#1A1613',
    gridLine: 'rgba(255,255,255,0.06)',
    hoverWash: 'rgba(255,255,255,0.03)',
    trackBg: 'rgba(255,255,255,0.06)',
  },
};

// Primary/secondary need different weights per ground to stay readable
export const BRAND = {
  light: { primary: '#A9761C', primaryLight: '#C89A3E', primaryDark: '#84590F', secondary: '#5C6672', onPrimary: '#FFFFFF' },
  dark: { primary: '#D9A441', primaryLight: '#F0C979', primaryDark: '#A87A28', secondary: '#B9C2CC', onPrimary: '#1A1410' },
};

export default TOKENS;
